<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:40
 * @LastEditors: 诺
 * @LastEditTime: 2023-02-02 16:57:58
-->
<template>
  <div
    class="model"
    :style="{ backgroundColor: `${bColor}80` }"
    v-if="data.length != 0"
  >
    <div
      class="modelTitle"
      :style="{ backgroundColor: bColor, color: textColor }"
    >
      {{ title }}
    </div>
    <div class="modelBg">
      <div :class="[`list`, `theme${theme}`]" >
        <div
          class="item"
          v-for="(item, index) in data"
          :key="index"
          @click="$emit('handleCoupon', item)"
        >
          <div class="itemMain" v-if="item.styleType == 1 && item.winType==4">
            <div class="itemInfo">
              <div class="typeName" :style="{ color: bColor }">{{ item.type == 4 ? "折扣" : "立减" }}</div>
              <div class="couponTitle">{{ item.name }}</div>
              <div class="couponInfo">{{ item.info }}</div>
            </div>
            <div class="itemIntro">
              <div class="itemIntroBox">
                <div class="reduce" v-if="item.type == 4">
                  <span> {{ item.discount }}</span> 折
                </div>
                <div class="reduce" v-if="item.type == 5" >
                  <span> {{ item.reduce }}</span
                  >元
                </div>
                <!-- <div class="receive" :style="{ backgroundColor: bColor, color: textColor }">立即领取</div> -->
                <div class="receive">立即领取</div>
              </div>
            </div>
          </div>
          
          <div class="itemMain" v-if="item.styleType == 1 && item.winType==5">
            <div class="itemInfo" :class="{theme1: $configInfo.uiExt.uiExtTemplate === 1}">
              <div class="couponTitle">{{ item.name }}</div>
              <div class="couponInfo" v-html="item.text"></div>
            </div>
            <div class="itemIntro">
              <div class="itemIntroBox">
                <div class="reduce" >
                  ￥<span>{{ item.amount / 100 }}</span>
                </div>
                <div class="receive" >一键锁定</div>
              </div>
            </div>
          </div>
          <!-- <div class="itemMain" v-if="item.styleType == 2" :style="{ backgroundImage: ` url(${item.img})` }"> -->
          <!-- <div class="itemMain" v-if="item.styleType == 2"> -->
            <img  v-if="item.styleType == 2" :src="item.img"/>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor", "title", "textColor", "theme"],
  data() {
    return {};
  },
  watch: {
    data: {
      handler(val) {
        val.map((item) => {
          item.text=(item.info||'').replace(/\n/g, '<br/>')
        });
      },
      deep: true,
    },
  },
  created() {
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
img{width:100%;}
.model {
  width: 351px;
  margin: 36px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
  padding: 10px;

  .modelTitle {
    position: absolute;
    margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    border-radius: 0px 0px 12px 12px;
    z-index: 1;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 40px 15px 19px;
      .item {
        margin-bottom: 14px; 

        .itemMain {
          min-height: 100px;
          // width: 311px;
          // background-image: url('https://assets.rurushishi.com/activies/activityCenter/planting/coupon.png');
          background-position: top center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;

          .itemInfo {
            border-radius: 8px;
            width: 270px;
            padding: 29px 70px 29px 20px;
            box-sizing: border-box;
            height: 100%;
            min-height: 100px;
            display: flex;
            flex-direction: column;

            .typeName {
              // margin-top: 18px;
              // margin-left: 20px;
              width: 40px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background: rgba(255, 255, 255, 0.4);
              border-radius: 4px;
              font-weight: 600;
              font-size: 12px;
            }

            .couponTitle {
              font-weight: 500;
              font-size: 18px;
              line-height: 24px;
              color: #ffffff;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 180px;
            }

            .couponInfo {
              width: 180px;
              font-size: 12px;
              line-height: 16px;
              color: rgba(255, 255, 255, 0.6);
              margin-top: 2px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .itemIntro {
            width: 96px;
            margin: 10px 0 10px -60px;
            border-radius: 0 6px 6px 0;
            background: #E8EDF0;
            box-shadow: 2px 0px 2px rgba(81, 118, 167, 0.5), inset 1px 0px 2px rgba(122, 161, 198, 0.5);
            padding: 5px 5px 5px 2px;
            .itemIntroBox {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              // margin:
              width: 100%;
              height: 100%;
              border: 1px solid #CCD3D7;
              border-left: none;
              box-sizing: border-box;
              border-radius: 2px;
            }

            .discount,
            .reduce {
              font-size: 14px;

              span {
                font-family: DIN Alternate;
                font-style: normal;
                font-weight: bold;
                font-size: 32px;
              }
            }

            .receive {
              width: 70px;
              height: 24px;
              margin-top: 5px;
              background: #076BDF;
              border-radius: 12px;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              color: #ffffff;
              text-align: center;
            }
          }
        }
      }
      
      &.theme0 {
        .itemInfo {
          background: linear-gradient(180deg, #1ABBFF 0%, #0285FA 75.52%);
          box-shadow: 0px 0px 8px rgba(78, 173, 241, 0.5), inset 0px -1px 0px rgba(58, 154, 255, 0.7), inset 0px 1px 0px rgba(173, 237, 255, 0.5);
        }
      }
      &.theme1 {
        .itemInfo {
          background: linear-gradient(180deg, #55DFE4 0%, #15B1B7 75.52%);
          box-shadow: 0px 0px 8px rgba(28, 158, 166, 0.5), inset 0px -1px 0px rgba(12, 141, 149, 0.7), inset 0px 1px 0px rgba(229, 255, 250, 0.5);
        }
      }
      &.theme2,&.theme4 ,&.theme5 {
        .itemInfo {
          background: linear-gradient(180deg, #F89147 4.69%, #F0672E 44.27%, #E84424 83.33%);
          box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2), inset 0px -1px 0px rgba(166, 43, 17, 0.5), inset 0px 1px 0px rgba(255, 195, 158, 0.5);
        }
        .typeName{
          color: #E94D26;
        }
        .couponInfo{
          color: #F2D5AB;
        }
        .itemMain{
          .itemIntro{
            background: #FFECD1;
            box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
            .itemIntroBox{
              border-color:  #F1CEB6;
              .reduce{
                color:#E94D26
              }
              .receive{
                background:#E94D26;
              }
            }
          }
        }
      }
      
      &.theme3 {
        .itemInfo {
          background: linear-gradient(180deg, #F7912B 0%, #CF5103 100%);
          box-shadow: 0px 0px 8px rgba(198, 78, 4, 0.5), inset 0px -1px 0px rgba(160, 62, 1, 0.7), inset 0px 1px 0px rgba(255, 226, 182, 0.5);
        }
        .typeName{
          color: #D05204;
        }
        .couponInfo{
          color: #FFFFFF;
        }
        .itemMain{
          .itemIntro{
            background: #FFFAF5;
            box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.2), inset 1px 0px 2px rgba(231, 117, 12, 0.5);
            .itemIntroBox{
              border-color:  #E1BFAA;
              .reduce{
                color:#F2782D
              }
              .receive{
                background:#F2782D;
              }
            }
          }
        }
      }
    }
  }
}
</style>
